class SizeGuideDrawer extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("sizeguidedrawer:click", () => {
      this.show();
    });
    super.connectedCallback();

  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }
}
customElements.define("size-guide-drawer", SizeGuideDrawer);